module.exports = __webpack_public_path__ + "img/DAY6-1.46f88e61.jpg";